export enum StreamViews {
    NONE = 0,
    USER_STATS = 1,
    USER_INTRO = 2,
    SCORES = 3,
    RESULTS = 4,
}
